import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
export var DifficultyLevelItem = React.memo(function (_a) {
    var isReachable = _a.isReachable, isSelected = _a.isSelected, _b = _a.isLocked, isLocked = _b === void 0 ? true : _b, onClick = _a.onClick;
    var idIcon = IdIcon.RatingStarEmptyIcon;
    if (isSelected) {
        idIcon = IdIcon.RatingStarFillIcn;
    }
    else if (isLocked) {
        idIcon = IdIcon.LockIcn;
    }
    var icon = (React.createElement("div", { onClick: onClick },
        React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: idIcon })));
    return isLocked ? addTooltip(icon, isReachable) : icon;
});
var addTooltip = function (item, isReachable) {
    if (!isReachable) {
        return (React.createElement(TooltipText, { id: IdLoca.comingSoon, anchor: IdTooltipAnchor.Bottom }, item));
    }
    return item;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/DifficultyLevelItem.tsx
// module id = 2594
// module chunks = 3